// ABOUTME: Shares the node-editor's save-in-progress state across sibling custom-page widgets.
// ABOUTME: Lets the action-bar Save action show a spinner and block re-fires while the editor mutation runs.

import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface NodeEditorSaveState {
    isSaving: boolean;
    setIsSaving: (isSaving: boolean) => void;
}

// Default is a no-op so widgets used outside a provider (e.g. in list view)
// still render without a save-state signal.
const NodeEditorSaveStateContext = createContext<NodeEditorSaveState>({
    isSaving: false,
    setIsSaving: () => {},
});

export const NodeEditorSaveStateProvider = ({ children }: { children: ReactNode }) => {
    const [isSaving, setIsSaving] = useState(false);
    const value = useMemo(() => ({ isSaving, setIsSaving }), [isSaving]);
    return (
        <NodeEditorSaveStateContext.Provider value={value}>
            {children}
        </NodeEditorSaveStateContext.Provider>
    );
};

export const useNodeEditorSaveState = () => useContext(NodeEditorSaveStateContext);
